var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.location},[_c('div',{staticStyle:{"margin":"8px 0px"}},[_c('h4',{staticClass:"tile-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }